import useExportOffers from "@features/offers/hooks/useExportOffers"
import useRefreshOffers from "@features/offers/hooks/useRefreshOffers"
import { useUser } from "@features/user"
import type { FC } from "react"
import { Trans } from "react-i18next"
import { Spinner as SpinnerIcon } from "../icons"
import ActionToolbar from "./ActionToolbar"
import Button from "./Button"

const OffersActionButtons: FC = () => {
  const { data } = useUser()
  const { refreshOffers, refreshing } = useRefreshOffers()
  const { loadingImport, exportOffers, importOffers } = useExportOffers()

  return (
    <ActionToolbar>
      {data?.can.manageUsers && (
        <Button
          className="inline-flex items-center"
          primary
          medium
          onClick={importOffers}
          disabled={loadingImport}
        >
          {loadingImport && (
            <SpinnerIcon className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" />
          )}
          <Trans i18nKey="offers.buttons.importExcel" />
        </Button>
      )}
      {data?.can.manageUsers && (
        <Button
          className="inline-flex items-center"
          primary
          medium
          onClick={exportOffers}
        >
          <Trans i18nKey="offers.buttons.exportExcel" />
        </Button>
      )}
      <Button
        className="inline-flex items-center"
        primary
        medium
        onClick={refreshOffers}
        disabled={refreshing}
      >
        {refreshing && (
          <SpinnerIcon className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" />
        )}
        <Trans i18nKey="offers.buttons.refresh" />
      </Button>
    </ActionToolbar>
  )
}

export default OffersActionButtons
